/** Same three values as the legacy AddKind so ProjectCanvas wiring is a drop-in. */
export type AttachKind = 'documents' | 'epics' | 'work-items';

/** Normalized candidate row, shared across all kinds. */
export interface AttachCandidate {
  id: string;
  title: string;
  /** Doc type name, or 'story' | 'bug' | 'task'. undefined for epics (no Type column). */
  typeLabel?: string;
  ownerName: string | null;
  /** Document lifecycle (draft/published/archived) or work-item status string. null if N/A. */
  lifecycle: string | null;
  updatedAt: string; // ISO
  createdAt: string; // ISO
  /** Documents only — body preview for the preview pane. */
  bodyExcerpt?: string;
}

export type SortKey = 'title' | 'type' | 'owner' | 'updated' | 'created';
export type SortDir = 'asc' | 'desc';

/** Combined search + filter predicate state. Search and filters compose with AND (EC-19). */
export interface FilterState {
  q: string;
  /** Selected lifecycle/status values; empty array = all (no lifecycle filter). */
  lifecycles: string[];
  typeIds: string[];
  ownerIds: string[];
  createdAfter?: string;
  createdBefore?: string;
}
export const EMPTY_FILTERS: FilterState = { q: '', lifecycles: [], typeIds: [], ownerIds: [] };
